module.exports = __webpack_public_path__ + "img/pro_night_1.2ba88640.jpg";